import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createElement } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
var SUCCESS_TOAST_CLASS_NAME = "flex items-center gap-3 rounded-sds-200 !bg-sds-success-default px-4 py-3 text-style-body-small-strong !text-sds-success-on-success shadow-sds-400";
var ERROR_TOAST_CLASS_NAME = "flex items-center gap-3 rounded-sds-200 !bg-sds-urgent-default px-4 py-3 text-style-body-small-strong !text-sds-urgent-on-urgent shadow-sds-400";

/** Shows a success notification styled with the SDS success tokens. */
export function showSuccessToast(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toast.success(message, _objectSpread({
    icon: /*#__PURE__*/createElement(FontAwesomeIcon, {
      icon: faCircleCheck,
      className: "text-sds-success-on-success"
    }),
    className: SUCCESS_TOAST_CLASS_NAME
  }, options));
}

/** Shows an error notification styled with the SDS urgent tokens. */
export function showErrorToast(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toast.error(message, _objectSpread({
    icon: /*#__PURE__*/createElement(FontAwesomeIcon, {
      icon: faTriangleExclamation,
      className: "text-sds-urgent-on-urgent"
    }),
    className: ERROR_TOAST_CLASS_NAME
  }, options));
}
var LEGACY_ERROR_TOAST_CLASS_NAME = "rounded-md flex mb-5 last:mb-8 !bg-yellow-700 dark:!text-black !text-white dark:!bg-yellow-100 !border !border-yellow-400 dark:!border-yellow-500";

/** Shows an error notification matching the legacy app toast design (bottom-centre, amber). */
export function showLegacyErrorToast(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return toast.error(message, _objectSpread({
    icon: /*#__PURE__*/createElement(FontAwesomeIcon, {
      icon: faTriangleExclamation,
      className: "text-yellow-400 dark:text-yellow-500"
    }),
    className: LEGACY_ERROR_TOAST_CLASS_NAME,
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: true
  }, options));
}